
// helpers/metrics-normalizer.js
export function normalizeAdvancedGroups(metricsJson) {
  if (!metricsJson || typeof metricsJson !== 'object') {
    return { efficiency: {}, leverage: {}, profitability: {} };
  }

  // Backend already sends correct groups: efficiency, leverage, profitability
  const efficiency = metricsJson.efficiency ?? {};
  const leverage = metricsJson.leverage ?? {};
  const profitability = metricsJson.profitability ?? {};

  return { efficiency, leverage, profitability };
}
